// extracted by mini-css-extract-plugin
module.exports = {"container":"ExtraInfoButton_container__lhwig","button":"ExtraInfoButton_button__VqNbs","iconVertical":"ExtraInfoButton_iconVertical__kJmdW","icon":"ExtraInfoButton_icon__G2h2B"};